import React, { use, useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import ContentHeader from '../../../Layout/ContentHeader'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import {
  CREATE_FORM,
  GET_ALL_FORMS,
  GET_ONE_FORM_BY_ID,
  UPDATE_FORM,
} from '../../../../graphql/Catalog/Forms/forms'
import { GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3 } from '../../../../graphql/Catalog/Groups/groupsCategories'
import { get } from 'lodash'

export const FormsNew = () => {
  const { id: _id } = useParams()
  const history = useHistory()
  const { showLoading, hideLoading } = useLoading()

  //STATES:
  const [icon, setIcon] = useState('')
  const [categories, setCategories] = useState([])

  //MUTATIONS:
  const [createForm] = useMutation(CREATE_FORM, {
    refetchQueries: [
      {
        query: GET_ALL_FORMS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  const [updateForm] = useMutation(UPDATE_FORM, {
    refetchQueries: [
      {
        query: GET_ALL_FORMS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
      { query: GET_ONE_FORM_BY_ID, variables: { formId: parseInt(_id) } },
    ],
  })

  //QUERIES:
  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_ONE_FORM_BY_ID, {
    variables: {
      formId: parseInt(_id),
    },
  })

  const { data: dataGroupsSub, loading:loadingGroupsSub, error:errorGroupsSub } = useQuery(
    GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3,
    {
      variables: {
        groupId: 1,
        form_id: parseInt(_id ? _id : 0),
        getAvailable: !_id,
      },
      fetchPolicy: 'no-cache',
    }
  )

  //FORM:
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo requerido'),
    description: Yup.string().required('Campo requerido'),
    diplay_name: Yup.string().required('Campo requerido'),
    icon: Yup.string().required('Campo requerido'),
    group_category_sub_id: Yup.string().required('Campo requerido'),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  //EFFECTS:

  useEffect(() => {
    if(!loadingGroupsSub){
      if(errorGroupsSub){
        return toastSweetAlert({
          mode: 'error',
          message: errorGroupsSub.message,
        })
      }

      if(dataGroupsSub){
        const arrayFormatCategories = []
        const arrayFormatSubs = []
    
        dataGroupsSub.getAllGroupsCategoriesAndSubsByGroupIdQuery.map((item) => {
          const options = item.subs.map((sub) => ({
            value: sub.id,
            label: sub.name,
            category_group_name: item.name,
            ...sub,
          }))

          item.subs.map((sub) => (
            arrayFormatSubs.push({
              value: sub.id,
              label: sub.name,
            })
          ))
    
          arrayFormatCategories.push({
            value: item.name,
            label: item.name,
            options,
          })
          return true
        })
    
        setCategories(arrayFormatCategories)
      }
    }
  }, [dataGroupsSub, loadingGroupsSub, errorGroupsSub])

  useEffect(() => {
    if (!loading) {
      if (_id) {
        if (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }

        if (dataResp !== undefined && dataResp !== null) {
          const data = dataResp.getOneFormById

          const dataFormated = {
            name: data.name,
            description: data.description,
            diplay_name: data.diplay_name,
            display_name_plural: data.display_name_plural,
            icon: data.icon,
            group_category_sub_id: data.GroupsCategoriesSubOfForm
              ? data.GroupsCategoriesSubOfForm.id
              : null,
          }

          if (data.icon) setIcon(`fas fa-${data.icon}`)

          reset(dataFormated)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataResp, error, loading])

  const onSubmit = async (dataForm) => {
    const input = {
      name: dataForm.name,
      description: dataForm.description,
      diplay_name: dataForm.diplay_name,
      display_name_plural: dataForm.display_name_plural,
      icon: dataForm.icon,
      group_category_sub_id: parseInt(dataForm.group_category_sub_id),
    }

    showLoading()
    try {
      if (_id) {
        await updateForm({ variables: { formId: parseInt(_id), input } })
        return (
          toastSweetAlert({
            mode: 'ok',
            message: 'Se actualizo correctamente',
          }),
          history.push(`/catalog/forms`)
        )
      } else {
        await createForm({ variables: { input } })
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Se creo con exito',
          },
          history.push(`/catalog/forms`)
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title="Formulario dinamico"
        breadcrumb=""
        windowTitle={`${_id ? 'Editar' : 'Agregar'} formulario `}
      />
      <FormProvider {...methods}>
        <form className="p-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${_id ? 'Editar' : 'Agregar nuevo'} formulario`}
            btnRedPath="/catalog/forms"
            btnRedTxt="Cancelar"
            errors={errors}
            btnSubmit={true}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      label="Nombre formulario"
                      name="name"
                      type="text"
                      placeholder="Escribe nombre"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      label="Descripcion"
                      name="description"
                      type="text"
                      placeholder="Escribe Descripcion"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      label="Titulo a mostrar"
                      name="diplay_name"
                      type="text"
                      placeholder="Escribe titulo a mostrar"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      label="Titulo a mostrar en plural"
                      name="display_name_plural"
                      type="text"
                      placeholder="Escribe titulo (plural) a mostrar"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-md-12 col-lg-3">
                    <label>Icon</label>
                    <div className="input-group">
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          id="inputGroupAppend"
                        >
                          <i className={icon}></i>
                        </span>
                      </div>
                      <InputController
                        type="text"
                        name="icon"
                        placeholder="FontAwesome icon"
                        aria-describedby="inputGroupAppend"
                        control={control}
                        changeAction={(e) =>
                          setIcon(`fas fa-${e.target.value}`)
                        }
                      />
                    </div>
                  </div>
                  <div className="mb-3 col-md-12 col-lg-9">
                    <InputController
                      label="Categoría"
                      type="text"
                      name="group_category_sub_id"
                      inputType="choosen"
                      options={categories}
                      control={control}
                      placeholder="Elige"
                      noOptionsMessage={() => 'Sin resultado'}
                      isClearable
                      value={getValues('group_category_sub_id')}
                      choosenOptions
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}
export default FormsNew
